import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function testimonialsReducer(state = initialState.testimonials, action) {
  if (action.type === types.LOAD_TESTIMONIALS_DATA_SUCCESS) {
    return action.testimonials;
  }
  return state;
}
